export default "__VITE_ASSET__DfeHP7sC__"